// extracted by mini-css-extract-plugin
module.exports = {"button":"primary-button_button__bn2hY","redesign":"primary-button_redesign__FpkJT","standalone":"primary-button_standalone___rLs6","secondary":"primary-button_secondary__Jw1ch"};